module.exports = __webpack_public_path__ + "prod/1.2.3/img/wait.75989fad.svg";